import React from 'react';

export const ArrowRightIcon = ({ width = 24, height = 24, color = "#FFFEFA", className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                className={className}
                d="M10 17L15 12L10 7"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};